import { Link } from 'react-router-dom';
import './landing.css';
import Accordion from 'react-bootstrap/Accordion';
import { useEffect,useContext,useState/*,useRef*/ } from 'react';
import { useAuth } from 'react-oidc-context';
import AppContext from '../../AppContext';
import UserContext from '../../UserContext';
import { useNavigate } from 'react-router-dom';


export default function LandingEdu() {
    const auth = useAuth();
    const appcontext = useContext(AppContext);
    const usercontext = useContext(UserContext);
	const [curuser,setCurUser]=useState(null);
	const [hasedu,setHasEdu]=useState(false);
	const [canbuyedu,setCanBuyEdu]=useState(false);
    let navigate = useNavigate();

    useEffect(() => {
	const checkPrimoAccesso=async function(){
		const user=usercontext.user;
		if(user.professione);else return navigate('/profilo/primoaccesso/?redirect='+encodeURIComponent(document.location.href));
	};
	if(usercontext && usercontext.user)
		checkPrimoAccesso();
    }, [appcontext,auth,usercontext,navigate]);

    useEffect(() => {
	const checkUser=async function(){
		const user=usercontext.user;
		setCurUser(user);
	};
	if(usercontext && usercontext.user)
		checkUser();
    }, [appcontext,auth,usercontext]);
    useEffect(() => {
		if(curuser){
			if(curuser.has_edu_upto && curuser.has_edu_upto>(new Date()).valueOf())setHasEdu(true);
		}
	},[curuser]);
    useEffect(() => {
		if(auth && auth.isAuthenticated && appcontext && appcontext.features && (!appcontext.features.bundle2026))return setCanBuyEdu(true);
		else return setCanBuyEdu(false);
	},[auth,appcontext,hasedu]);


	return (
            <section className="landing-edu">
                  <div className='edu-top'>
                        <dvi className="top-headings">
                              <h1>Migliaia di risorse didattiche per preparare i tuoi esami di giurisprudenza.</h1>
                              {/*<h2>Approfitta subito della promo -50% <span>(€9,00/mese)</span></h2>*/}
                        </dvi>
                  </div>
                  <div className='edu-cards'>
                        <div className='card'>
                              <div className='card-content'>
                                    <div className='content-top'>
                                          <div className='top-info'></div>
                                          <div className='bottom-info'>
                                                <div className='promo'>
                                                      <div className='promo-headings'>
                                                            <h2>EDU</h2>
                                                            <span>per 6 mesi</span>
                                                      </div>
                                                      <div className='promo-chip'>
                                                            <span>Promo -50%</span>
                                                      </div>
                                                </div>
                                                <div className='pricing'>
                                                      <h2>€ 4,50 /mese</h2>
                                                      <h3>Pagamento mensile, accesso valido per 6 mesi</h3>
                                                </div>
                                                <div className='action'>
                                                      {hasedu || (!canbuyedu)?(<Link to='/edu' className='gradient-button align-self-center button-disabled'>Acquista ora <img src={`${process.env.PUBLIC_URL}/arrow-w.svg`} /></Link>):(<Link to='/create-checkout/abbonamentoedu' className='gradient-button align-self-center'>Acquista ora <img src={`${process.env.PUBLIC_URL}/arrow-w.svg`} /></Link>)}
                                                </div>
                                                <div className='list'>
                                                      <h4>Include:</h4>
                                                      <div className='list-items'>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Accesso illimitato a tutte le materie EDU: le materie sono in continua fase di aggiornamento ed implementazione</span>
                                                            </div>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Migliaia di quiz di verifica e test di autovalutazione</span>
                                                            </div>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Mappe concettuali delle materie</span>
                                                            </div>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Casi di studio</span>
                                                            </div>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Glossari</span>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <div className='card'>
                              <div className='card-content'>
                                    <div className='content-top'>
                                          <div className='top-info'>
                                          </div>
                                          <div className='bottom-info'>
                                                <div className='promo'>
                                                      <div className='promo-headings'>
                                                            <h2>eBook + EDU</h2>
                                                            <span>per 6 mesi</span>
                                                      </div>
                                                      <div className='promo-chip'>
                                                            <span>Acquista un manuale</span>
                                                      </div>
                                                </div>
                                                <div className='pricingedu'>
                                                      <span>Acquistando un Manuale di Giappichelli Editore, con in copertina questo tag, avrai in omaggio l’accesso alla versione eBook del manuale ed a Giappichelli EDU, per 6 mesi!</span>
                                                </div>
						<div className='ebookedu'>
							<img src={`${process.env.PUBLIC_URL}/landing/ebookedu.png`} />
						</div>
                                                <div className='action'>
							<Link to='https://www.giappichelli.it/studenti-home' className='gradient-button align-self-center'>Acquista ora <img src={`${process.env.PUBLIC_URL}/arrow-w.svg`} /></Link>
                                                </div>
                                                <div className='list'>
                                                      <h4>Include:</h4>
                                                      <div className='list-items'>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Accesso illimitato a tutte le materie EDU: le materie sono in continua fase di aggiornamento ed implementazione</span>
                                                            </div>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Migliaia di quiz di verifica e test di autovalutazione</span>
                                                            </div>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Mappe concettuali delle materie</span>
                                                            </div>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Casi di studio</span>
                                                            </div>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Glossari</span>
                                                            </div>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Accesso all’ebook del manuale</span>
                                                            </div>
                                                            <div>
                                                                  <img src={`${process.env.PUBLIC_URL}/landing/list-item.svg`} />
                                                                  <span className='bold'>Accesso ai contenuti aggiuntivi creati dall’autore del manuale (se presenti)</span>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <div className='edu-info'>
                        <p>Pagamento sicuro. Offerta valida per il primo semestre, rinnovo automatico allo scadere dei 6 mesi.<br />Disdici quando vuoi</p>
                  </div>
                  <div className='edu-faq'>
                        <div>
                              <h1>Informazioni</h1>
                              <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                          <Accordion.Header>Cos'è Giappichelli EDU?</Accordion.Header>
                                          <Accordion.Body>
                                                <p>

							La piattaforma digitale Giappichelli Edu è uno strumento multimediale per la preparazione degli esami di giurisprudenza. E’ un ecosistema didattico ricco di casi di studio interattivi, mappe concettuali, quiz di verifica, test di autovalutazione ed un glossario; risorse didattiche create ad hoc dai migliori autori italiani che arricchiscono l’offerta del libro.
                                                </p>
                                          </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                          <Accordion.Header>Che metodi di pagamento posso usare?</Accordion.Header>
                                          <Accordion.Body>
                                                <p>
							Accettiamo tutte le carte di credito e debito supportate da Stripe ed il pagamento con le Carte della Cultura e del Merito.
                                                </p>
                                          </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                          <Accordion.Header>Come funziona l’accesso a Giappichelli EDU?</Accordion.Header>
                                          <Accordion.Body>
                                                <p>
							Dopo l’acquisto vai nella tua area personale e vedrai il box Giappichelli EDU in alto a destra. Cliccando sulle varie materie potrai accedervi e scoprire tutte le risorse didattiche incluse. Fai scroll per verificare tutte le materie attualmente disponibili.
                                                </p>
                                          </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="3">
                                          <Accordion.Header>Quali materie sono incluse?</Accordion.Header>
                                          <Accordion.Body>
                                                <p>
							Giappichelli EDU è in costante espansione. Attualmente offre centinaia di risorse didattiche per ognuna delle seguenti materie giuridiche: Diritto pubblico, Diritto costituzionale, Diritto privato, Diritto penale, Diritto del lavoro, Diritto amministrativo, Diritto dell’UE, Diritto commerciale e Diritto tributario.
                                                </p>
                                          </Accordion.Body>
                                    </Accordion.Item>
                              </Accordion>
                        </div>


                  </div>
            </section>
      );
}
